<template>
  <div class="list-help hit-cursor">
    <div
        @mouseenter="showPurchaseShow"
        @mouseleave="hidePurchaseShow"
        @click="changeOrder(true)" class="list-help-item">
      <img :src="require(`@/static/index/help/icon-1.png`)"/>
      <div :class="purchaseShow ? 'list-help-item-name-active' : 'list-help-item-name'">
        {{ purchaseShow ? '点击发布' : '发布询单' }}
      </div>
    </div>
    <div
        @mouseenter="showProductShow"
        @mouseleave="hideProductShow"
        @click="goHelp('/user/supplier/my-project')" class="list-help-item">
      <img :src="require(`@/static/index/help/icon-2.png`)"/>
      <div :class="productShow ? 'list-help-item-name-active' : 'list-help-item-name'">
        {{ productShow ? '点击发布' : '发布产品' }}
      </div>
    </div>
    <div
        class="list-help-item"
        @mouseenter="showWechatFun"
        @mouseleave="hideWechatFun"
    >
      <img :src="require(`@/static/index/help/icon-3.png`)"/>
      <div class="list-help-item-name">公众号</div>
    </div>
    <div
        class="list-help-item"
        @mouseenter="showMiniFun"
        @mouseleave="hideMiniFun"
    >
      <img :src="require(`@/static/index/help/icon-5.png`)"/>
      <div class="list-help-item-name">联系客服</div>
    </div>
    <div
        v-if="isLogin"
        class="list-help-item"
        @mouseenter="showBusinessFun"
        @mouseleave="hideBusinessFun"
    >
      <img :src="require(`@/static/index/help/icon-6.png`)"/>
      <div class="list-help-item-name">专属业务</div>
    </div>

    <!-- 公众号显示-->
    <div class="watch-popup" v-show="showWechat"
         @mouseenter="showWechatFun"
         @mouseleave="hideWechatFun"
    >
      <div class="watch-content">
        <img class="watch-img" :src="configInfo.wechat_qrcode" alt=""/>

        <div class="watch-text-title">
          <span>扫码关注公众号</span>
        </div>
      </div>
      <div class="watch-content">
        <img class="watch-img" :src="configInfo.mini_qrcode" alt=""/>

        <div class="watch-text-title">
          <span>立即体验小程序</span>
        </div>
      </div>
      <div class="hotline-arrow"></div>
    </div>
    <!--    专属客服-->
    <div class="mini-popup" v-show="showMini" @mouseenter="showMiniFun" @mouseleave="hideMiniFun">
      <!--      没有登录的时候显示的客服-->
      <div class="mini-content" v-if="!isLogin">
        <div class="service-card" v-for="(item,index) in service" :key="index">
          <div class="service-title">免费找货、比价、找客服联系我
            <a :href="item.qw_link" target="_blank">咨询微信客服</a>
          </div>
          <div class="content-body">
            <img :src="item.avatar" alt="qq头像" class="image-box">
            <div class="service-info">
              <div class="service-name">{{ item.name }}</div>
              <!--              <div class="service-desc">平均15分钟内报价</div>-->
            </div>
            <img :src="item.qrcode" alt="qq头像" class="qr-box">
          </div>
          <div class="service-actions">
            <el-button type="primary" class="contact-btn phone-btn" @click="copyHotline(item.mobile)">
              电话
              {{ item.mobile }}
            </el-button>
            <el-button type="primary" @click="copyHotline(item.qq)" class="contact-btn qq-btn">
              QQ
              {{ item.qq }}
            </el-button>
          </div>
        </div>
      </div>
      <!--      登录了之后显示的客服-->
      <div class="mini-content" v-else>
        <div class="service-card">
          <div class="service-title">免费找货、比价、找客服联系我
            <a :href="kefu.qw_link" target="_blank">咨询微信客服</a>
          </div>
          <div class="content-body">
            <img :src="kefu.avatar" alt="qq头像" class="image-box">
            <div class="service-info">
              <div class="service-name">{{ kefu.name }}</div>
              <!--              <div class="service-desc">平均15分钟内报价</div>-->
            </div>
            <img :src="kefu.qrcode" alt="qq头像" class="qr-box">
          </div>
          <div class="service-actions">
            <el-button type="primary" class="contact-btn phone-btn" @click="copyHotline(kefu.mobile)">
              电话
              {{ kefu.mobile }}
            </el-button>
            <el-button type="primary" @click="copyHotline(kefu.qq)" class="contact-btn qq-btn">
              QQ
              {{ kefu.qq }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="hotline-arrow"></div>
    </div>
    <!--    专属业务-->
    <div class="mini-business-popup" v-show="business&&isLogin"
         @mouseenter="showBusinessFun"
         @mouseleave="hideBusinessFun"
    >
      <div class="mini-content">
        <div class="service-card">
          <div class="service-title">免费找货、比价、找业务联系我
          </div>
          <div class="content-body">
            <img :src="yewu.avatar" alt="qq头像" class="image-box">
            <div class="service-info">
              <div class="service-name">{{ yewu.name || '' }}</div>
              <div class="service-desc">平均15分钟内报价</div>
            </div>
            <img :src="yewu.qrcode" alt="qq头像" class="qr-box">
          </div>
          <div class="service-actions">
            <el-button type="primary" class="contact-btn phone-btn" @click="copyHotline(yewu.mobile)">
              电话
              <!--              <i class="el-icon-mobile-phone"></i>-->
              {{ yewu.mobile }}
            </el-button>
            <el-button type="primary" @click="copyHotline(yewu.wechat)" class="contact-btn qq-btn">
              微信
              <!--              <i class="el-icon-copy-document"></i>-->
              {{ yewu.wechat }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="hotline-arrow"></div>
    </div>

  </div>
</template>
<script>
import {getWebSiteService} from '@/api/modules/common'
import {getMyCustomerService} from "@/api/modules/user";
import Post_Inquiry from "@/components/addInfo/post_Inquiry.vue";

export default {
  name: "help",
  components: {Post_Inquiry},
  props: {'showGZH': {default: false}},
  data() {
    return {
      showHotline: false,
      showWechat: false,
      showMini: false,
      business: false,
      productShow: false,
      purchaseShow: false,
      service: [],
      yewu: {},
      kefu: {},
      showInquiry: false,
      miniHideTimeout: null // 添加延迟计时器
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    if (this.isLogin) {
      this.customerService()
    }
  },
  watch: {
    showGZH(newVal) {
      if (newVal) {
        this.showWechatFun()
      } else {
        this.hideWechatFun()
      }
    }
    ,
    isLogin(newVal) {
      if (newVal) {
        this.customerService()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 修改询单状态
    changeOrder(e) {
      if (this.mixCheckLogin() && this.mixCheckUserAudit()) {
        this.showInquiry = e
      }
    },
    async init() {
      let res = await getWebSiteService()
      if (res.data.code === 10000) {
        this.service = res.data.data
      }
    },
    async customerService() {
      let res1 = await getMyCustomerService()
      if (res1.data.code === 10000) {
        this.yewu = res1.data.data.yewu
        this.kefu = res1.data.data.kefu
      }
    },
    showWechatFun() {
      this.showWechat = true;
    },
    hideWechatFun() {
      this.showWechat = false;
    },
    showMiniFun() {
      this.showMini = true;
      clearTimeout(this.miniHideTimeout);
    },
    showBusinessFun() {
      this.business = true;
      clearTimeout(this.miniHideTimeout);
    },
    hideBusinessFun() {
      this.business = false;
      this.miniHideTimeout = setTimeout(() => {
        this.business = false;
      }, 200);
    },
    hideMiniFun() {
      this.showMini = false;
      this.miniHideTimeout = setTimeout(() => {
        this.showMini = false;
      }, 200);
    },
    showProductShow() {
      this.productShow = true;
    },
    hideProductShow() {
      this.productShow = false;
    },
    showPurchaseShow() {
      this.purchaseShow = true;
    },
    hidePurchaseShow() {
      this.purchaseShow = false;
    },

    // 复制热线号码
    copyHotline(inner) {
      if (inner) {
        navigator.clipboard
            .writeText(inner)
            .then(() => {
              this.$message.success({
                message: "已复制到剪贴板",
                duration: 2000,
                offset: 200,
              });
            })
            .catch(() => {
              // 降级方案
              const textArea = document.createElement("textarea");
              textArea.value = inner;
              document.body.appendChild(textArea);
              textArea.select();
              document.execCommand("copy");
              document.body.removeChild(textArea);
              this.$message.success({
                message: "已复制到剪贴板",
                duration: 2000,
                offset: 200,
              });
            });
      }
    },
    goHelp(path) {
      if (this.mixCheckLogin()) {
        if (this.mixCheckUserAudit()) {
          this.$router.push(path);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.list-help {
  position: fixed;
  top: 30%;
  background: linear-gradient(135deg, #0540b8 0%, #0c60e6 100%);
  border-radius: 8px 0 0 8px;
  padding: 2px;
  box-sizing: border-box;
  z-index: 999;
  box-shadow: -2px 2px 10px rgba(5, 64, 184, 0.3);
  /* 应用滚动条补偿 */
  right: var(--scrollbar-width);

  .list-help-item {
    padding: 8px 5px;
    height: 66px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    font-size: 12px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;

    //&::before {
    //  content: "";
    //  position: absolute;
    //  top: 0;
    //  left: -100%;
    //  width: 100%;
    //  height: 100%;
    //  background: linear-gradient(
    //          90deg,
    //          transparent,
    //          rgba(255, 255, 255, 0.1),
    //          transparent
    //  );
    //  transition: left 0.5s ease;
    //}

    &:hover::before {
      left: 100%;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateX(-2px);
    }

    img {
      width: 28px;
      height: 28px;
      transition: all 0.3s ease;
      filter: brightness(0) invert(1);
      object-fit: contain;
      display: block;
      margin: 0 auto 8px auto;

      &:hover {
        transform: scale(1.15) rotate(5deg);
        filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(255, 255, 255, 0.3));
      }
    }

    .list-help-item-name {
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .list-help-item-name-active {
      font-weight: 700;
      letter-spacing: 0.5px;
      transition: all 0.2s ease;
      transform: scale(1.1);
    }

    &:last-child {
      border-bottom: none;
    }

    &:first-child {
      border-top: none;
    }
  }


  .watch-popup {
    position: fixed;
    right: 78px;
    top: 50%;
    transform: translateY(calc(-50% + 20px));

    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

    .watch-img {
      width: 150px;
      height: 150px;
      object-fit: contain;
    }

    .watch-text-title {
      font-weight: 300;
      font-size: 12px;
      text-align: center;
      margin-top: 10px;
    }
  }
}

.mini-popup {
  position: fixed;
  right: 78px;
  top: 42%;
  //transform: translateY(-50%);
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

  .mini-img {
    width: 150px;
    height: 150px;
    object-fit: contain;
  }

  .mini-text-title {
    font-weight: 300;
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
  }
}

.mini-business-popup {
  position: fixed;
  right: 78px;
  top: 50%;
  //transform: translateY(-60%);
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

  .mini-img {
    width: 150px;
    height: 150px;
    object-fit: contain;
  }

  .mini-text-title {
    font-weight: 300;
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
  }
}


.hotline-arrow {
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid #ffffff;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.1));
}

// 响应式设计
@media (max-width: 768px) {
  .list-help {
    right: 0;
    top: 50%;
    transform: translateY(-50%);

    .hot-line-phone {
      right: 70px;
      max-width: 180px;

      .phone-content {
        padding: 16px 20px;

        .phone-number {
          font-size: 14px;
        }

        .copy-text {
          font-size: 11px;
          padding: 6px 10px;
        }
      }
    }
  }
}

// 动画效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hot-line-phone {
  animation: fadeInUp 0.3s ease-out;
}

//客服列表
// ... existing code ...
.mini-content {
  .service-card {
    margin-bottom: 16px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;


    .service-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #0540b8;
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px dashed #e5e9f2;
    }

    .content-body {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      gap: 15px;

      .image-box {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 50%;
        border: 3px solid #e6f0ff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
      }

      .service-info {
        flex: 1;
        min-width: 0;

        .service-name {
          font-weight: 600;
          color: #333;
          margin-bottom: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .service-desc {
          font-size: 12px;
          color: #666;
        }
      }

      .qr-box {
        width: 90px;
        height: 90px;
        object-fit: contain;
        border: 1px solid #f0f0f0;
        padding: 5px;
        background: #fff;
      }
    }

    .service-actions {
      display: flex;
      gap: 10px;
      margin-top: 12px;

      .contact-btn {
        flex: 1;
        padding: 8px 0;
        border-radius: 6px;
        font-size: 13px;
        transition: all 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(12, 96, 230, 0.3);
        }

        &.phone-btn {
          background: #0c60e6;
          border-color: #0c60e6;
        }

        &.qq-btn {
          background: #2d8cf0;
          border-color: #2d8cf0;
        }
      }
    }
  }
}

// ... existing code ...

</style>
